<template>
	<v-container>
		<v-row>
			<v-col cols="12" class="d-flex flex-column justify-center">
				<h2 class="display-1 font-weight-light" v-text="$t('account.wallet.title', {
					name: account.data.firstname,
				})"></h2>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" lg="4">
				<VirtualWalletDetailsCard
					v-model="details"
					:cashless="balances"
					:skeleton="skeleton"
				/>
			</v-col>
			<v-col cols="12" lg="8">
				<VirtualWalletContent
					:admissions="admissions"
					:cashless="cashless"
					:addons="addons"
					:prePurchasedItems="prepurchasedItems"
					:skeleton="skeleton"
				/>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import VirtualWalletDetailsCard from '@/components/VirtualWalletDetailsCard';
import VirtualWalletContent from '@/components/VirtualWalletContent';
import { AccountModel, WalletModel, PaginationModel, EComService } from '@connectngo/sdk';

export default {
	name: 'Details',

	metaInfo() {
		return {
			title: this.$i18n.t('account.wallet.title', { name: this.account.data.firstname }),
			meta: [
				{ property: 'og:title', content: this.$i18n.t('account.wallet.title', { name: this.account.data.firstname }) },
				{ property: 'og:url', content: window.location.href },
				{ property: 'og:site_name', content: this.$options.filters.translatable(this.$root.websiteConfig.data.name, this.$root.websiteConfig.data.name_i18n, this.$i18n.locale) }
			],
		};
	},

	components: { VirtualWalletDetailsCard, VirtualWalletContent },

	data: () => ({
		skeleton: true,
		loading: false,
		account: new AccountModel(),
		details: new WalletModel(),
		balances: new PaginationModel(),
		admissions: new PaginationModel(),
		cashless: new PaginationModel(),
		prepurchasedItems: new PaginationModel(),
		addons: new PaginationModel(),
	}),

	methods: {
		load() {
			this.loading = true;
			return Promise.all([
				new EComService().getAccount(this.$route.params.sub),
				new EComService().getVirtualWallets(this.$route.params.sub),
				new EComService().getVirtualWalletCashlessBalances(this.$route.params.param1),
				new EComService().getVirtualWalletTickets(this.$route.params.param1),
				new EComService().getVirtualWalletCashlessLogs(this.$route.params.param1),
				new EComService().getVirtualWalletAddonLogs(this.$route.params.param1),
				new EComService().getVirtualWalletPrepurchasedItemLogs(this.$route.params.param1),
			])
				.then(([account, wallets, balances, admissions, cashless, addons, prepurchasedItems]) => {
					const details = wallets.results.find(wallet => wallet.data.id == this.$route.params.param1);
					Object.assign(this, { account, details, balances, admissions, cashless, prepurchasedItems, addons });

					this.$route.meta.sub = this.$options.filters.shortUserName(account);
					this.$route.meta.param1 = details.getUidLabel();
					this.$breadcrumbs.refresh();

					this.skeleton = false;
				})
				.catch(reason => this.$handleError(this, reason))
				.finally(() => (this.loading = false));
		},
	},

	created() {
		this.$route.meta.sub = this.$i18n.t('state.loading');
		this.$route.meta.param1 = this.$i18n.t('state.loading');
		this.load();
	},
}
</script>
